/* ============================================================
   Ranglistenseite — Sortieren, Filtern, Detail-Schublade, Vergleich.

   Die Zeilen stehen bereits im HTML; hier wird nur umsortiert und
   ausgeblendet. Ohne JavaScript bleibt die vollstaendige Liste in der
   Reihenfolge der Wertung sichtbar.
   ============================================================ */
(function () {
  "use strict";
  var root = document.querySelector("[data-iprk]");
  if (!root) return;

  var CAT = root.dataset.cat;
  var listEl = root.querySelector("[data-rows]");
  var rows = Array.prototype.slice.call(root.querySelectorAll(".iprk-row"));
  if (!rows.length) return;

  var SWATCH = {
    black: "#1a1a1a", white: "#f2f2f0", grey: "#8b8f8c", silver: "#c4c8c9", carbon: "#2b2f31",
    red: "#c8232c", "dark-blue": "#1e3a6e", "light-blue": "#4aa3d8", green: "#2f7d43",
    yellow: "#e8c433", "neon-yellow": "#d8e832", orange: "#e2751f", purple: "#6b3fa0",
    pink: "#e07aa8", gold: "#c9a227", bronze: "#a5713f", beige: "#d9cbb0", brown: "#6b4a2f"
  };
  function paintSwatches(scope) {
    (scope || document).querySelectorAll("[data-sw]").forEach(function (el) {
      var c = SWATCH[el.getAttribute("data-sw")];
      if (c) el.style.background = c;
    });
  }
  paintSwatches(root);

  var num = function (el, k) { return parseFloat(el.dataset[k]) || 0; };
  var state = { sort: "rank", shape: "", flags: {}, band: null, colour: null, size: null, brand: null, cmp: [] };

  /* ---------------- Filtern und Sortieren ---------------- */
  function passes(r) {
    if (state.shape && r.dataset.form !== state.shape) return false;
    for (var f in state.flags) if (state.flags[f] && r.dataset[f] !== "1") return false;
    if (state.band) {
      var p = num(r, "price"), b = state.band.split("-");
      if (p < +b[0] || p >= +b[1]) return false;
    }
    if (state.colour && ("|" + r.dataset.colours + "|").indexOf("|" + state.colour + "|") < 0) return false;
    if (state.size && ("|" + r.dataset.sizes + "|").indexOf("|" + state.size + "|") < 0) return false;
    if (state.brand && r.dataset.brand !== state.brand) return false;
    return true;
  }

  var SORTS = {
    rank: function (a, b) { return num(a, "rank") - num(b, "rank"); },
    cheap: function (a, b) { return num(a, "price") - num(b, "price") || num(a, "rank") - num(b, "rank"); },
    dear: function (a, b) { return num(b, "price") - num(a, "price") || num(a, "rank") - num(b, "rank"); },
    light: function (a, b) { return num(a, "weight") - num(b, "weight") || num(a, "rank") - num(b, "rank"); },
    value: function (a, b) { return val(b) - val(a) || num(a, "rank") - num(b, "rank"); },
    cov: function (a, b) { return num(b, "cov") - num(a, "cov") || num(a, "rank") - num(b, "rank"); },
    colours: function (a, b) { return num(b, "nc") - num(a, "nc") || num(a, "rank") - num(b, "rank"); },
    brand: function (a, b) { return a.dataset.brand.localeCompare(b.dataset.brand) || num(a, "rank") - num(b, "rank"); }
  };
  function val(r) { var p = num(r, "price"); return p ? num(r, "score") / (p / 100) : 0; }

  /* Die letzte Datenspalte zeigt, wonach gerade sortiert wird. */
  var LEAD = {
    value: { label: "Value", text: function (r) { return val(r).toFixed(1) + " pts/100"; } },
    colours: { label: "Colourways", text: function (r) { return r.dataset.nc; } },
    brand: { label: "Brand", text: function (r) { return r.dataset.brand; } }
  };

  var NOTES = {
    rank: "Ranked by this discipline's matrix. Positions stay with the helmet when you re-sort, so you can always see where it really finished.",
    value: "Best value divides the score by the price: points per 100. It rewards a cheap helmet that scores well — it does not say the top of the list is the better helmet.",
    cov: "Coverage is how much of the 85-point matrix we could answer from documented facts. High coverage means the score rests on evidence, not on gaps.",
    light: "Sorted by measured weight. Helmets with no published weight sit at the end — that is missing data, not a heavy helmet."
  };

  function apply() {
    var visible = rows.filter(passes);
    rows.forEach(function (r) { r.hidden = visible.indexOf(r) < 0; });

    visible.slice().sort(SORTS[state.sort] || SORTS.rank).forEach(function (r) { listEl.appendChild(r); });

    /* Angepasste Spalte */
    var lead = LEAD[state.sort];
    var head = root.querySelector('.iprk-th [data-col="lead"]');
    if (head) head.textContent = lead ? lead.label : (head.dataset.def || "Coverage");
    rows.forEach(function (r) {
      var c = r.querySelector('[data-col="lead"]');
      if (c) c.textContent = lead ? lead.text(r) : c.dataset.covText;
    });
    ["weight", "lead", "price"].forEach(function (col) {
      var on = (state.sort === "light" && col === "weight")
        || ((state.sort === "cheap" || state.sort === "dear") && col === "price")
        || (lead && col === "lead");
      root.querySelectorAll('[data-col="' + col + '"]').forEach(function (el) { el.classList.toggle("is-lead", !!on); });
    });

    var n = root.querySelector("[data-count]");
    if (n) n.textContent = visible.length;
    var empty = root.querySelector("[data-empty]");
    if (empty) empty.hidden = visible.length > 0;
    var note = root.querySelector("[data-note]");
    if (note) note.textContent = NOTES[state.sort] || "";

    var active = !!(state.shape || state.band || state.colour || state.size || state.brand)
      || Object.keys(state.flags).some(function (k) { return state.flags[k]; });
    var clear = root.querySelector("[data-clear]");
    if (clear) clear.hidden = !active;

    var nf = 0;
    if (state.shape) nf += 1;
    ["band", "colour", "size", "brand"].forEach(function (k) { if (state[k]) nf += 1; });
    Object.keys(state.flags).forEach(function (k) { if (state.flags[k]) nf += 1; });
    var badge = root.querySelector("[data-fcount]");
    if (badge) { badge.textContent = nf; badge.hidden = nf === 0; }
  }

  /* Standardbeschriftung der angepassten Spalte merken */
  var headLead = root.querySelector('.iprk-th [data-col="lead"]');
  if (headLead) headLead.dataset.def = headLead.textContent.trim();

  /* ---------------- Aufklapper ---------------- */
  function box(which) {
    return which === "sort" ? root.querySelector("[data-sortpop]") : root.querySelector("[data-panelbox]");
  }
  function trigger(which) {
    return which === "sort" ? root.querySelector("[data-sortbtn]") : root.querySelector("[data-panel]");
  }
  function isOpen(which) { var b = box(which); return b && !b.hidden; }
  function toggleDrop(which, open) {
    ["sort", "panel"].forEach(function (w) {
      var b = box(w), tr = trigger(w);
      if (!b || !tr) return;
      var want = w === which ? open : false;   /* immer nur einer offen */
      b.hidden = !want;
      tr.setAttribute("aria-expanded", String(want));
    });
  }
  document.addEventListener("click", function (ev) {
    if (ev.target.closest(".iprk-drop") || ev.target.closest("[data-panelbox]")) return;
    toggleDrop(null, false);
  });

  /* ---------------- Bedienung ---------------- */
  root.addEventListener("click", function (ev) {
    var t = ev.target;

    var ax = t.closest("[data-ax]");
    if (ax) { ax.parentNode.classList.toggle("is-open"); return; }

    var sh = t.closest("[data-shape]");
    if (sh) {
      state.shape = sh.dataset.shape || "";
      root.querySelectorAll("[data-shape]").forEach(function (b) { b.classList.toggle("is-on", b === sh); });
      apply(); return;
    }

    var sortBtn = t.closest("[data-sortbtn]");
    if (sortBtn) { toggleDrop("sort", !isOpen("sort")); return; }

    var so = t.closest("[data-sort]");
    if (so) {
      state.sort = so.dataset.sort;
      root.querySelectorAll(".iprk-popi").forEach(function (b) { b.classList.toggle("is-on", b.dataset.sort === state.sort); });
      var chosen = root.querySelector('.iprk-popi[data-sort="' + state.sort + '"] b');
      var label = root.querySelector("[data-sortlabel]");
      if (chosen && label) label.textContent = chosen.textContent;
      toggleDrop("sort", false);
      apply();
      if (so.dataset.goto) {
        var target = document.getElementById(so.dataset.goto);
        if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
      }
      return;
    }

    var panelBtn = t.closest("[data-panel]");
    if (panelBtn) { toggleDrop("panel", !isOpen("panel")); return; }

    if (t.closest("[data-clear]")) {
      state.shape = ""; state.flags = {}; state.band = null; state.colour = null; state.size = null; state.brand = null;
      root.querySelectorAll(".iprk-pf").forEach(function (b) { b.classList.remove("is-on"); });
      root.querySelectorAll("[data-shape]").forEach(function (b) { b.classList.toggle("is-on", !b.dataset.shape); });
      apply(); return;
    }

    var pf = t.closest(".iprk-pf");
    if (pf) {
      var on = !pf.classList.contains("is-on");
      if (pf.dataset.flag) { state.flags[pf.dataset.flag] = on; pf.classList.toggle("is-on", on); }
      else {
        var kind = pf.dataset.band ? "band" : pf.dataset.colour ? "colour" : pf.dataset.size ? "size" : "brand";
        var value = pf.dataset[kind];
        state[kind] = on ? value : null;
        pf.parentNode.querySelectorAll(".iprk-pf").forEach(function (b) { b.classList.toggle("is-on", b === pf && on); });
      }
      apply(); return;
    }

    var open = t.closest("[data-open]");
    if (open) { ev.preventDefault(); openDrawer(open.closest(".iprk-row")); return; }

    var pick = t.closest("[data-pick]");
    if (pick) { togglePick(pick.dataset.pick); return; }
    var un = t.closest("[data-unpick]");
    if (un) { togglePick(un.dataset.unpick); return; }
    if (t.closest("[data-compare]")) { showCompare(); return; }

    if (t.closest("[data-close]") || t.classList.contains("iprk-dr__bd") || t.classList.contains("iprk-cmp")) {
      root.querySelector("[data-drawer]").hidden = true;
      root.querySelector("[data-cmp]").hidden = true;
    }
  });

  document.addEventListener("keydown", function (ev) {
    if (ev.key !== "Escape") return;
    toggleDrop(null, false);
    root.querySelector("[data-drawer]").hidden = true;
    root.querySelector("[data-cmp]").hidden = true;
  });

  /* ---------------- Detail-Schublade ---------------- */
  var cache = {};
  function fetchDetail(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
    return fetch(base.replace(/\/$/, "") + "/products/" + handle + "?section_id=rank-detail")
      .then(function (r) { return r.ok ? r.text() : Promise.reject(new Error(r.status)); })
      .then(function (html) { cache[handle] = html; return html; });
  }

  function openDrawer(row) {
    if (!row) return;
    var dr = root.querySelector("[data-drawer]");
    var body = root.querySelector("[data-drawerbody]");
    body.innerHTML = '<p class="iprk-muted">…</p>';
    dr.hidden = false;
    fetchDetail(row.dataset.handle).then(function (html) {
      body.innerHTML = html;
      /* Nur die Disziplin dieser Seite zeigen; faellt sie aus, die erste. */
      var secs = body.querySelectorAll(".iprk-dsec");
      var shown = false;
      secs.forEach(function (s) {
        var match = s.dataset.cat === CAT;
        s.hidden = !match;
        if (match) shown = true;
      });
      if (!shown && secs[0]) secs[0].hidden = false;
      paintSwatches(body);
      var pickBtn = body.querySelector("[data-pick]");
      if (pickBtn) pickBtn.setAttribute("aria-pressed", String(state.cmp.indexOf(row.dataset.handle) >= 0));
      body.scrollTop = 0;
    }).catch(function () {
      body.innerHTML = '<p class="iprk-muted">The detail could not be loaded. The helmet’s own page has everything.</p>';
    });
  }

  /* ---------------- Vergleich ---------------- */
  function rowOf(handle) { return rows.filter(function (r) { return r.dataset.handle === handle; })[0]; }

  function togglePick(handle) {
    var i = state.cmp.indexOf(handle);
    if (i >= 0) state.cmp.splice(i, 1);
    else if (state.cmp.length < 3) state.cmp.push(handle);
    root.querySelectorAll("[data-pick]").forEach(function (b) {
      b.setAttribute("aria-pressed", String(state.cmp.indexOf(b.dataset.pick) >= 0));
    });
    drawTray();
  }

  function drawTray() {
    var tray = root.querySelector("[data-tray]");
    tray.hidden = state.cmp.length === 0;
    var slots = root.querySelector("[data-trayslots]");
    slots.innerHTML = [0, 1, 2].map(function (i) {
      var h = state.cmp[i];
      if (!h) return '<span class="iprk-tslot"></span>';
      var r = rowOf(h), img = r ? r.querySelector(".iprk-tile img") : null;
      return '<span class="iprk-tslot is-full">' + (img ? '<img src="' + img.src + '" alt="">' : "") +
        '<button type="button" data-unpick="' + h + '" aria-label="Remove">✕</button></span>';
    }).join("");
    root.querySelector("[data-traylabel]").textContent =
      state.cmp.length < 2 ? state.cmp.length + " selected — pick at least two" : state.cmp.length + " selected · up to three";
    root.querySelector("[data-compare]").disabled = state.cmp.length < 2;
  }

  function showCompare() {
    if (state.cmp.length < 2) return;
    var box = root.querySelector("[data-cmp]");
    var body = root.querySelector("[data-cmpbody]");
    body.innerHTML = '<p class="iprk-muted">…</p>';
    box.hidden = false;

    Promise.all(state.cmp.map(fetchDetail)).then(function (htmls) {
      var picked = state.cmp.map(function (h, i) {
        var doc = new DOMParser().parseFromString(htmls[i], "text/html");
        var node = doc.querySelector('[data-axes="' + CAT + '"]') || doc.querySelector("[data-axes]");
        var axes = null;
        try { axes = node ? JSON.parse(node.textContent) : null; } catch (e) { axes = null; }
        return { handle: h, row: rowOf(h), axes: axes };
      }).filter(function (p) { return p.row; });

      var heads = picked.map(function (p) {
        var img = p.row.querySelector(".iprk-tile img");
        return '<div class="iprk-cmpcard"><span class="iprk-tile">' + (img ? '<img src="' + img.src + '" alt="">' : "") +
          "</span><b>" + p.row.querySelector(".iprk-row__n b").textContent + '</b><u>' +
          p.row.dataset.score + '</u><span class="iprk-fine">' +
          p.row.querySelector(".iprk-row__pr").textContent.trim() + "</span></div>";
      }).join("");

      var matrix = "";
      var withAxes = picked.filter(function (p) { return p.axes && p.axes.cats; });
      if (withAxes.length === picked.length) {
        var names = picked[0].axes.cats.map(function (c) { return c.n; });
        matrix = names.map(function (n, i) {
          var vals = picked.map(function (p) { return (p.axes.cats[i] || {}).p || 0; });
          var mx = Math.max.apply(null, vals), mn = Math.min.apply(null, vals), tie = mx === mn;
          return "<tr><td>" + n + " <span class=\"iprk-muted\">/ " + ((picked[0].axes.cats[i] || {}).m || 0) + "</span></td>" +
            vals.map(function (v) { return '<td class="' + (!tie && v === mx ? "is-win" : "") + '">' + v + "</td>"; }).join("") + "</tr>";
        }).join("");
      }

      var extras = [
        ["Weight", function (r) { return num(r, "weight") >= 99999 ? "—" : r.dataset.weight + " g"; }],
        ["Shape", function (r) { return (r.dataset.form || "—").replace(/-/g, " "); }],
        ["Homologation", function (r) { return (r.dataset.ece === "1" ? "ECE 22.06" : "—") + (r.dataset.fim === "1" ? " + FIM" : ""); }],
        ["Colourways", function (r) { return r.dataset.nc !== "0" ? r.dataset.nc : "—"; }],
        ["Coverage", function (r) { return r.dataset.cov + " %"; }],
        ["Value", function (r) { return val(r).toFixed(1) + " pts/100"; }],
        ["From", function (r) { return r.querySelector(".iprk-row__pr").textContent.trim(); }]
      ].map(function (x) {
        return "<tr><td>" + x[0] + "</td>" + picked.map(function (p) { return "<td>" + x[1](p.row) + "</td>"; }).join("") + "</tr>";
      }).join("");

      body.innerHTML =
        '<div class="iprk-cmphead" style="grid-template-columns:repeat(' + picked.length + ',1fr)">' + heads + "</div>" +
        '<div class="iprk-cmpscroll"><table class="iprk-mtx"><thead><tr><th>Scored area</th>' +
        picked.map(function (p) { return "<th>" + p.row.querySelector(".iprk-row__n b").textContent + "</th>"; }).join("") +
        "</tr></thead><tbody>" + matrix +
        '<tr><td colspan="' + (picked.length + 1) + '" style="height:.5rem;border:0"></td></tr>' +
        extras + "</tbody></table></div>";
    });
  }

  /* Auswahl auch direkt aus der Zeile (Doppel-Aufgabe des Öffnen-Knopfs
     vermeiden: der Vergleich wird in der Schublade angeboten). */
  drawTray();

  /* Schwesterseiten beim Überfahren vorladen — der Disziplinwechsel ist ein
     echter Seitenwechsel, soll sich aber nicht so anfühlen. */
  var prefetched = {};
  root.addEventListener("mouseover", function (ev) {
    var a = ev.target.closest("[data-prefetch]");
    if (!a || prefetched[a.href]) return;
    prefetched[a.href] = 1;
    var l = document.createElement("link");
    l.rel = "prefetch"; l.href = a.href;
    document.head.appendChild(l);
  }, { passive: true });

  apply();
})();
